<template>
  <common-template>
    <template v-slot:body>
      <main-kind-contents />
    </template>
  </common-template>
</template>

<script>
import MainKindContents from '@/components/kind/MainKindContents';
import CommonTemplate from '@/components/templates/CommonTemplate';

const canonical = location.href.match(/\/$/) === null ? `${location.href}/` : location.href;

export default {
  name: 'MainKind',
  metaInfo() {
    return {
      link: [
        { rel: 'canonical', href: canonical },
      ],
    };
  },
  components: {
    MainKindContents,
    CommonTemplate,
  },
};
</script>

<style scoped lang="scss">
@charset "UTF-8";

</style>
